(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["xamea-announcement"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-xamea-announcement]').forEach((root) => {
    if (root.dataset.announcementReady === 'true') return;
    root.dataset.announcementReady = 'true';

    const messages = Array.from(root.querySelectorAll('[data-announcement-message]'));
    const toggle = root.querySelector('[data-announcement-toggle]');
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const interval = Math.max(4000, Number(root.dataset.interval) || 6000);
    let activeIndex = Math.max(0, messages.findIndex((message) => message.classList.contains('is-active')));
    let timer;
    let userPaused = false;
    let interactionPaused = false;

    if (messages.length < 2 || reduceMotion) return;

    const render = (nextIndex) => {
      messages[activeIndex].classList.remove('is-active');
      messages[activeIndex].setAttribute('aria-hidden', 'true');
      activeIndex = nextIndex;
      messages[activeIndex].classList.add('is-active');
      messages[activeIndex].setAttribute('aria-hidden', 'false');
    };

    const stop = () => {
      window.clearTimeout(timer);
      root.classList.remove('is-cycling');
    };

    const schedule = () => {
      stop();
      if (userPaused || interactionPaused || document.hidden) return;
      void root.offsetWidth;
      root.classList.add('is-cycling');
      timer = window.setTimeout(() => {
        render((activeIndex + 1) % messages.length);
        schedule();
      }, interval);
    };

    const updateToggle = () => {
      if (!toggle) return;
      toggle.setAttribute('aria-pressed', String(userPaused));
      toggle.setAttribute('aria-label', userPaused ? toggle.dataset.playLabel : toggle.dataset.pauseLabel);
    };

    toggle?.addEventListener('click', () => {
      userPaused = !userPaused;
      updateToggle();
      schedule();
    });

    root.addEventListener('mouseenter', () => {
      interactionPaused = true;
      schedule();
    });

    root.addEventListener('mouseleave', () => {
      interactionPaused = false;
      schedule();
    });

    root.addEventListener('focusin', () => {
      interactionPaused = true;
      schedule();
    });

    root.addEventListener('focusout', (event) => {
      if (root.contains(event.relatedTarget)) return;
      interactionPaused = false;
      schedule();
    });

    document.addEventListener('visibilitychange', schedule);
    schedule();
  });

  } catch(e) { console.error(e); }
})();
})();
